import React from "react";

const HairColorTrend = () => {
  return (
    <div className="headSpaWhyContainer">
      <h5>Trends in Hair Colour in Bangalore & Hair Highlights in Bangalore</h5>
      <p>
        Bangalore is a city that loves to experiment with style, and this is
        reflected in the ever-evolving trends in{" "}
        <a href="https://scentlifestyle.com/hair-highlights-and-streaks">
          Hair Highlights in Bangalore
        </a>
        . Some of the popular trends we see at SCENT include:
      </p>
      <ul>
        <li>
          <span>Balayage and Ombre:</span> These techniques offer a natural,
          gradient effect that mimics the way hair naturally lightens in the
          sun. They are perfect for adding depth and dimension to your hair.
        </li>
        <li>
          <span>Vibrant Colors:</span> From pastel pinks to electric blues, bold
          and vibrant hair colors are a great way to make a statement. Our
          stylists can help you choose the perfect shade to match your
          personality.
        </li>
        <li>
          <span> Natural Tones:</span> For those who prefer a more understated
          look, natural tones like caramel, honey, and chocolate are always in
          style. These colors add warmth and richness to your hair.
        </li>
        <li>
          <span> Face-Framing Highlights:</span> These strategically placed
          highlights around the face can enhance your features and brighten your
          complexion. They are a subtle yet effective way to refresh your look.
        </li>
      </ul>
    </div>
  );
};

export default HairColorTrend;
